"use client";

import { c as _c } from "react/compiler-runtime";
import { numberConvert } from "@website/utils/number-convert";
import type { FC } from "react";
import { useChatbotVisibility } from "../chat-bot/chatbot-experiment";
type ContactPhoneProperties = {
  classNames: {
    item: string;
    key: string;
    value: string;
  };
  phoneNumbers: Array<{
    text: string;
    value: string;
  }>;
  phoneNumberPrefix: string;
};
export const ContactPhone: FC<ContactPhoneProperties> = t0 => {
  const $ = _c(24);
  const {
    classNames,
    phoneNumbers,
    phoneNumberPrefix
  } = t0;
  const showChatbot = useChatbotVisibility();
  const isVisibilityPending = showChatbot === null;
  if (showChatbot === true) {
    return null;
  }
  const t1 = isVisibilityPending || undefined;
  const t2 = `${classNames.item} ${isVisibilityPending ? "invisible" : ""}`;
  let t3;
  if ($[0] !== classNames.key) {
    t3 = <div className={classNames.key}>تلفن:</div>;
    $[0] = classNames.key;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const t4 = classNames.value;
  const t5 = `tel:${phoneNumbers[0].value}`;
  let t6;
  if ($[2] !== phoneNumbers[0].text) {
    t6 = numberConvert(phoneNumbers[0].text, {
      numberOnly: false,
      locale: "fa"
    });
    $[2] = phoneNumbers[0].text;
    $[3] = t6;
  } else {
    t6 = $[3];
  }
  let t7;
  if ($[4] !== t5 || $[5] !== t6) {
    t7 = <a href={t5} itemScope={true}>{t6}</a>;
    $[4] = t5;
    $[5] = t6;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  const t8 = `tel:${phoneNumbers[1].value}`;
  let t9;
  if ($[7] !== phoneNumbers[1].text) {
    t9 = numberConvert(phoneNumbers[1].text, {
      numberOnly: false,
      locale: "fa"
    });
    $[7] = phoneNumbers[1].text;
    $[8] = t9;
  } else {
    t9 = $[8];
  }
  let t10;
  if ($[9] !== t8 || $[10] !== t9) {
    t10 = <a href={t8} itemScope={true}>{t9}</a>;
    $[9] = t8;
    $[10] = t9;
    $[11] = t10;
  } else {
    t10 = $[11];
  }
  let t11;
  if ($[12] !== phoneNumberPrefix) {
    t11 = numberConvert(phoneNumberPrefix, {
      numberOnly: false,
      locale: "fa"
    });
    $[12] = phoneNumberPrefix;
    $[13] = t11;
  } else {
    t11 = $[13];
  }
  let t12;
  if ($[14] !== classNames.value || $[15] !== t10 || $[16] !== t11 || $[17] !== t7) {
    t12 = <div className={t4}>{t7}  -  {t10}  ({t11})</div>;
    $[14] = classNames.value;
    $[15] = t10;
    $[16] = t11;
    $[17] = t7;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  let t13;
  if ($[19] !== t1 || $[20] !== t12 || $[21] !== t2 || $[22] !== t3) {
    t13 = <div aria-hidden={t1} className={t2}>{t3}{t12}</div>;
    $[19] = t1;
    $[20] = t12;
    $[21] = t2;
    $[22] = t3;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  return t13;
};